import axios from "axios/index";
import * as types from "../store/mutation-types";
import store from '~/store'

export default {
    async getFolderDetail (buildingId, cb) {
        if (typeof(buildingId) != "undefined") {
            const params = {}

            const {data} = await axios.get('/api/folder/' + buildingId, params)
            cb(data.folders, data.files)
        }
    },

    async createFolder (buildingId, parentFolderId, folderName) {
        const {data} = await axios.post('/api/folder/' + buildingId, {
            parent_id: parentFolderId,
            name: folderName,
        })
        store.commit('folder/'+types.SET_FOLDER_DETAIL, {folders: data.folders, files: data.files})
    },

    async deleteFolder (buildingId, folderId, cb) {
        const params = {}

        const {data} = await axios.delete('/api/folder/'+buildingId+'/'+folderId, {})
        store.commit('folder/'+types.SET_FOLDER_DETAIL, {folders: data.folders, files: data.files})

        cb()
    },

}


// WEBPACK FOOTER //
// ./resources/assets/js/api/folder.js